class Accordion {
  constructor (el) {
    this.$el = $(el);
    this.$$btns = this.$el.find('.js-acc-btn');
  }

  init() {
    this.$$btns.each((_, btn) => {
      const $item = $(btn).closest('.js-acc-item');
      const $content = $item.find('.js-acc-content');

      $(btn).on('click', event => {
        event.preventDefault();
        $item.toggleClass('is-open');

        if ($item.hasClass('is-open')) {
          $content.slideDown();
        } else {
          $content.slideUp();
        }

      });
    });
  }

  static initAll() {
    $('.js-accordion').each((i, el) => {
      const acc = new this(el);
      acc.init();
    });
  }

}


export default Accordion;
